export var YesOrNoNum;
(function (YesOrNoNum) {
    YesOrNoNum[YesOrNoNum["Yes"] = 1] = "Yes";
    YesOrNoNum[YesOrNoNum["No"] = 0] = "No";
})(YesOrNoNum || (YesOrNoNum = {}));
